import { render, staticRenderFns } from "./FamilyOtp.vue?vue&type=template&id=ea7eb6e2&"
import script from "./FamilyOtp.vue?vue&type=script&lang=js&"
export * from "./FamilyOtp.vue?vue&type=script&lang=js&"
import style0 from "./FamilyOtp.vue?vue&type=style&index=0&id=ea7eb6e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports